<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      @mouseover="$emit('hoverStart')"
      @mouseleave="$emit('hoverEnd')"
      max-width="650"
      @dblclick.stop
      :elevation="!hover ? 1 : 2"
      class="pa-1"
      :class="{ grey: selected, 'lighten-3': selected, 'no-events': draggingCardId == card.id }"
      :style="
        `left: ${pos.x}px; top: ${pos.y}px; position: absolute; z-index: ${dragging ? 2 : 1};`
      "
    >
      <note-page
        @mousedown.left.stop="startDragSelect"
        :colIndex="colIndex"
        :key="card.id"
        :pageId="card.pageId"
        :dashboardView="false"
        :pinned="true"
        :nestedPage="true"
        class="white mb-1 pr-2"
        :showToolbar="false"
        style=""
        @close=""
        @expand=""
        @toggleLock=""
      ></note-page>
      <div
        @mousedown.stop.prevent="dragStart"
        style="height: 30px; background: #eee; width: 100%;"
      ></div>
    </v-card>
  </v-hover>
</template>

<script>
import { inject } from '@vue/composition-api';
export default {
  components: { 'note-page': () => import('@/views/Context/components/ContentSection/NotePage') },
  props: ['card', 'pos', 'pz', 'selected', 'draggingCardId', 'hoverContext', 'hoverPage'],
  setup() {
    const colIndex = inject('colIndex');
    return { colIndex };
  },
  data() {
    return {
      dragging: false,
      startPos: {
        view: {
          // relative to viewport
          x: 0,
          y: 0
        },
        canvas: {
          //  relative to canvas position
          x: 0,
          y: 0
        }
      }
    };
  },
  computed: {},
  methods: {
    dragStart(e) {
      console.log(e);
      if (e.shiftKey) {
        console.log('remove tag');
        this.$emit('removeFromTag', this.card.id);
      }
      this.dragging = true;
      this.startPos = {
        view: {
          x: e.x,
          y: e.y
        },
        canvas: {
          x: this.pos.x,
          y: this.pos.y
        }
      };
      this.$emit('dragStart');
      document.addEventListener('mousemove', this.updatePos);
      document.addEventListener('mouseup', this.dragEnd);
    },
    dragEnd() {
      this.dragging = false;
      this.$emit('dragEnd');
      document.removeEventListener('mousemove', this.updatePos);
      document.removeEventListener('mouseup', this.dragEnd);
    },
    updatePos(e) {
      const { scale } = this.pz.getTransform();
      const { view, canvas } = this.startPos;
      const changeLeft = e.x - view.x;
      const left = canvas.x + changeLeft / scale;
      const changeRight = e.y - view.y;
      const right = canvas.y + changeRight / scale;
      this.$emit('updatePosition', {
        id: this.card.id,
        x: left,
        y: right
      });
      //console.log(e);
    }
  }
};
</script>

<style>
.no-events {
  pointer-events: none;
}
</style>
